// app/javascript/controllers/fixed_asset_fields_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "container", "field"]

  connect() {
    this.toggle()
  }

  toggle() {
    const active = this.checkboxTarget.checked

    this.containerTarget.classList.toggle("d-none", !active)

    this.fieldTargets.forEach((field) => {
      field.disabled = !active
    })
  }
}
